import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=23620327&scoped=true"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=23620327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23620327",
  null
  
)

export default component.exports